import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import swal from "sweetalert";
import { CiRedo } from "react-icons/ci";
import { isMobile } from "react-device-detect";
import Style from "../../../assets/jsStyles";
import { productsList } from "../../../config/products";
import softCodingImage from '../../../assets/images/soft_coding.png'
import ReactTooltip from "react-tooltip";
import { MapContext } from '../../../context/MapContext'
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const formData = new FormData();
const config = require("../../../config");

const EDC15Form = (props) => {
  var dWidth = "400px";
  if (isMobile) {
    dWidth = "90%";
  }

  const [vin, setVin] = useState("");
  const [number, setNumber] = useState("");
  const [otp, setOtp] = useState("")
  const [type, setType] = useState("2");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailErrorText, setEmailErrorText] = useState("")
  const [vinColor, setVinColor] = useState("black");
  const [numberColor, setNumberColor] = useState("black");
  const [emailColor, setEmailColor] = useState("black");
  const [userSubmittedCaptcha, setUserSubmittedCaptcha] = useState("");
  const [captchaCode, setCaptchaCode] = useState("");
  const [showImage, setShowImage] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false);


  const handleHover = () => {
    console.log("this is handle hover")
    setShowImage(true)
    console.log("this is show Image", showImage)

  };

  const handleLeave = () => {
    console.log("this is show Image in leave", showImage)
    console.log("this is mouse leave")
    setShowImage(false);
  };

  // const generateCaptchaCode = () => {
  //   const characters =
  //     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  //   let captchaCode = "";
  //   for (let i = 0; i < 4; i++) {
  //     const randomIndex = Math.floor(Math.random() * characters.length);
  //     captchaCode += characters[randomIndex];
  //   }
  //   return captchaCode;
  // };

  // const handleEmailVerify = async () => {
  //   console.log("this is the email", email)
  //   const requestData = {
  //     email: email
  //   }
  //   try {
  //     const response = await fetch("http://localhost:8080/mock-tms/register", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(requestData),
  //     });
  //     const data = await response.json();
  //     console.log("this is the response for the handleEmailVerify response", data)
  //     if (data.code === 0) {
  //       setShowOtpModal(false)
  //       setVerifiedEmail(true);
  //     }
  //     else if (data.code === 1) {
  //       console.log("this is the new user")
  //       setShowOtpModal(true)
  //     }
  //   }
  //   catch (error) {
  //     console.log("this is the error in the verify email", error)
  //   }
  // };

  // const handleClose = () => {
  //   setShowOtpModal(false)
  // }

  const sendOtp = async () => {
    setLoading(true); // Set loading to true before sending OTP
    const requestData = {
      email: email
    }
    try {
      const response = await fetch(`${config.HOST}/otp/generate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      console.log("this is the response for the handleEmailVerify response", data)
      if (data.code === 0) {
        setEmailError(data.message)
      }
      else if (data.code === 1) {
        console.log("successful")
        setEmailSent(true)
      }
    }
    catch (error) {
      console.log("this is the error in the verify email", error)
    }
    finally {
      setLoading(false); // Set loading back to false after sending OTP
    }
  }

  // const generateNewCaptcha = () => {
  //   const newCaptchaCode = generateCaptchaCode();
  //   setCaptchaCode(newCaptchaCode);
  //   setUserSubmittedCaptcha("");
  // };

  // useEffect(() => {
  //   generateNewCaptcha();
  // }, []);

  useEffect(() => {
    if (new RegExp("[A-Z0-9]{17}", "").test(vin)) {
      setVinColor("green");
    } else {
      setVinColor("black");
    }
    if (new RegExp("[0-9]{5}", "").test(number)) {
      setNumberColor("green");
    } else {
      setNumberColor("black");
    }
  }, [vin, number]);

  const mainFormOnSubmit = (evt) => {
    evt.preventDefault();
    console.log("this is the otp", otp,"-->", number,"-->", type,"-->", vin,"-->", email,"-->", password)
    
    formData.delete("vin");
    formData.delete("number");
    formData.delete("type");
    formData.delete("email", email);
    formData.delete("password");
    formData.delete("otp")

    formData.append("vin", vin);
    formData.append("number", number);
    formData.append("type", type);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("otp", otp)
    let vinCheck = new RegExp("[A-Z0-9a-z]{17}", "g").test(vin);
    let numberCheck = new RegExp("[0-9]{5}", "g").test(number);
    let typeCheck = new RegExp("[1-5]{1}", "g").test(type);
    // let captchaTest = captchaCode === userSubmittedCaptcha ? true : false;
    let emailCheck = true;

    if (!vinCheck) {
      setVinColor("red");
    }
    if (!numberCheck) {
      setNumberColor("red");
    }
    // if (!captchaTest) {
    //   generateCaptchaCode()
    // }
    if (!email || email === "") {
      setEmailColor("red");
      emailCheck = false;
    }

    if (vinCheck && numberCheck && typeCheck) {
      props.setLoader(true);
      axios
        .post(`${config.HOST}/file/upload`, formData)
        .then((res) => {
          console.log("this is the success response", res.data.data)
          props.setLoader(false);
          swal({
            title: "File Converted Successfully!",
            text: "Pay and download your file instantly.",
            icon: "success",
            button: "Pay Now",
          }).then((flag) => {
            if (flag) {
              window.location = res.data.data;
              //props.setProduct(res.data.data, parseInt(type));
            }
          });
        })
        .catch((e) => {
          props.setLoader(false);
          console.log(e.response.data);
          swal({
            title: "Something went wrong.",
            text: e.response.data.message,
            icon: "error",
          });
        });
    } else {
      let errorMessage = "";

      errorMessage += vinCheck ? "" : "Invalid VIN. ";
      errorMessage += numberCheck ? "" : "Invalid datablock id/soft coding. ";
      errorMessage += typeCheck ? "" : "No type selected.";
      // errorMessage += captchaTest ? "" : "Invalid Captcha";
      errorMessage += emailCheck ? "" : "Invalid Email";

      swal({
        title: "Invalid Inputs",
        text: errorMessage,
        icon: "error",
      });
    }
  };

  const uploadFile = (evt) => {
    evt.preventDefault();
    let file = evt.target.files[0];
    console.log("this is the file in the edc", file)
    formData.delete("binFile");
    if (file) {
      formData.append("binFile", file);
      console.log("file", file)
    }
    console.log(file)
  };

  return (
    <>
      <form data-testid="edc-form" onSubmit={mainFormOnSubmit} style={Style.form}>
        <input
          type="file"
          onChange={uploadFile}
          name="binFile"
          accept=".bin, .Bin, .BIN"
          placeholder="Put your bin file here"
          style={Style.uploadButton('dWidth')}
        ></input>
        {process.env.REACT_APP_ENV !== "PROD" ? (
          <input
            type="password"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            name="password"
            placeholder="Enter Password"
            style={Style.formInput(dWidth, vinColor)}
            value={password}
          ></input>
        ) : null}
        <div>
          <input
            data-tip="Contact Support if you don't have VIN in VCDS"
            data-type="warning"
            type="text"
            onChange={(e) => {
              if (e.target.value.length <= 17) {
                setVin(e.target.value.toUpperCase());
              }
            }}
            name="vin"
            placeholder="VIN-17 digit alphanumeric"
            style={Style.formInput(dWidth, vinColor)}
            value={vin}
          ></input>
        </div>
        <ReactTooltip effect='solid' />
        <div
          style={{
            display: 'flex',
            width: dWidth
          }}>
          <input
            type="text"
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailSent(false)
            }}
            name="email"
            placeholder="Enter your email"
            style={Style.formInput(dWidth, emailColor)}
            value={email}
          ></input>

          {(!emailSent && !loading) && <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: '8px',
              padding: '0px 15px',
              color: 'white',
              background: 'blue',
              borderRadius: '10px'
            }}
            className="text-xs"
            onClick={sendOtp}
          >Send <span className="ml-1">OTP</span></div>
          }
          {
            (!emailSent && loading)&& <div className="loader text-sm"   
               style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: '8px',
              padding: '0px 15px',
              color: 'white',
              background: 'blue',
              borderRadius: '10px'
            }} > <FontAwesomeIcon icon={faSpinner} spin /></div>
          }
          {emailSent&&<div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: '8px',
              padding: '0px 20px',
              color: 'white',
              background: 'rgb(106,181,39)',
              borderRadius: '10px',
              fontSize: '12px'
            }}
          >Sent <span>✓</span></div>
          }
        </div>
        {emailError && <div style={{
          paddingLeft: "32px",
          color: "red"
        }}>
          {emailErrorText}</div>}

          <div>
          <input
            type="text"
            onChange={(e) => {
              if (e.target.value.length <= 6) {
                setOtp(e.target.value);
              }
            }}
            name="OTP"
            placeholder="OTP"
            style={Style.formInput(dWidth,vinColor )}
            value={otp}
          ></input>
        </div>

        {/* {showOtpModal && <Otp_verification onClose={handleClose} />} */}
        <input
          type="text"
          onChange={(e) => {
            if (e.target.value.length <= 5) {
              setNumber(e.target.value);
            }
          }}
          onMouseEnter={handleHover}
          onMouseLeave={handleLeave}
          placeholder="datablock id/soft coding"
          style={Style.formInput(dWidth, numberColor)}
          name="number"
          value={number}
        ></input>

        {showImage && (
          <img
            src={softCodingImage} // Replace with the actual path to your image
            alt="Description"
            style={{ maxWidth: isMobile ? "90%" : "90%", maxHeight: "100%", position: "relative", marginLeft: "10%" }}
          />

        )}

        <select
          data-testid="select-option"
          onChange={(e) => {
            setType(e.target.value);
          }}
          style={Style.formInput(dWidth, "black")}
          name="type"
          value={type}
        >

          {productsList.edc15.map((data, i) => {
            return (
              
              <option value={`${i + 2}`}> 
                {data.description} &euro; {data.price}
              </option>
            );
          })}
          {/* 
                    //value for mapswitch with cruise is 2 and with pedals is 3
          
          option value="1">Launch control &euro;70</option>
                    <option value="2">
                        Mapswitch with cruise control &euro;65
                    </option>
                    <option value="3">Mapswitch with pedals &euro;65</option> 
                    <option value="4">
                        LC + mapswitch with cruise &euro;125
                    </option>
                    <option value="5">
                        LC + mapswitch with pedals &euro;125
                    </option> */}
        </select>
        {/* <div style={Style.recaptchaOuter(dWidth)}>
          <div style={Style.captchaBox()}>
            {" "}
            <span data-testid='captcha-code'>{captchaCode}</span>{" "}

            <CiRedo id="retryButton" onClick={generateNewCaptcha} />
          </div>

          <input
            type="text"
            data-testid="captcha-code-input"
            name="clientCode"
            onChange={(e) => {
              setUserSubmittedCaptcha(e.target.value);
            }}
            style={Style.formInput("90%", "black")}
            value={userSubmittedCaptcha}
          />
        </div> */}
        <input
          type="submit"
          style={Style.formInput(dWidth, "black", "50px", "18px")}
          value="Pay & Download"
        />
      </form>
      <p style={Style.disclaimer}>
        *All data must be from engine ECU.<br></br>
        *No refunds, make sure all data is correct.
      </p>
    </>
  );
};

export default EDC15Form;
